// Local Variables
const { ssrWebpackPublicPath } = globalThis || {};

if (ssrWebpackPublicPath) {
  // eslint-disable-next-line camelcase -- Webpack's API
  __webpack_public_path__ = ssrWebpackPublicPath;
}
